var styles = {"img":"EventHorizonPromoBanner-module_img__aD6uZ","container":"EventHorizonPromoBanner-module_container__Nar75","button":"EventHorizonPromoBanner-module_button__2JXKl"};

export { styles as default };
